<template>
  <!-- 面包屑导航 -->
  <el-breadcrumb class="app-breadcrumb" separator="/">
    <transition-group name="breadcrumb">
      <template v-for="(item,index) in levelList">
        <el-breadcrumb-item  v-if="item.meta.title" :key="item.path">
        <span v-if="item.redirect==='noredirect'||index==levelList.length-1" class="no-redirect">{{ generateTitle(item.meta.title) }}</span>
        <span v-else>{{ generateTitle(item.meta.title) }}</span>
      </el-breadcrumb-item>
      </template>
    </transition-group>
  </el-breadcrumb>
</template>

<script>
import { generateTitle } from '@/utils/i18n'
export default {
  data() {
    return {
      levelList: null
    }
  },
  watch: {
    $route() {
      this.getBreadcrumb()
    }
  },
  created() {
    this.getBreadcrumb()
  },
  methods: {
    getBreadcrumb() {
      // 过滤掉不正常的路径留下可用的
      let matched = this.$route.matched.filter(item => item.name)
      const first = matched[0]
      // 暂时只有首页是一级菜单，别的都是两级，所以这里判断，若不是home，就在父菜单后面拼接上所点击的子菜单，形成面包屑导航
      if (first && first.name.trim().toLocaleLowerCase() !== 'Home'.toLocaleLowerCase()) {
        matched = [{path: '', meta: { title: first.parent.meta.title }}].concat(matched)
      }
      this.levelList = matched
    },
    generateTitle
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .app-breadcrumb.el-breadcrumb {
    display: inline-block;
    font-size: 14px;
    line-height: 50px;
    margin-left: 10px;
    .no-redirect {
      cursor: text;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Breadcrumb/index.vue